module.exports = __webpack_public_path__ + "static/media/wifi.54cab756.png";